module.exports = __webpack_public_path__ + "img/img614.19265cf3.png";